import { lazy, Suspense, type FC } from 'react';

const HpRecentlySearchedItemsModule = lazy(
    () =>
        import(
            /* webpackChunkName: "HpRecentlySearchedItemsModule" */ './HpRecentlySearchedItemsModule.tsx'
        )
);

export const HpRecentlySearchedItemsModuleLazy: FC = () => (
    <Suspense fallback="">
        <HpRecentlySearchedItemsModule />
    </Suspense>
);
